export default __webpack_public_path__ + "static/media/thomas.cd20b602.png";